export default __webpack_public_path__ + "static/media/Logo-Banner.f231561c.png";